import { render, staticRenderFns } from "./DeleteIntershipNewsPopup.vue?vue&type=template&id=1d34039e"
import script from "./DeleteIntershipNewsPopup.vue?vue&type=script&lang=js"
export * from "./DeleteIntershipNewsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports